<template>
  <div class="view-tasklists">
    <user-menu />
    <div class="wrapper">
    <masteradmin-sidebar-menu />
    <div class="content-wrapper">
    <div class="container-wrapper center">
      <div>
        <h3 class="d-inline heading">NAICS Lists</h3>
        <button class="d-inline btn btn-blue float-right create-btn ml-1" @click="isUploadModalVisible = true, verrors.clear()">
          Upload CSV
        </button>
        <button class="d-inline btn btn-blue float-right create-btn" @click="isModalVisible = true, verrors.clear()">
          <i class="fa fa-plus spacer-icon" aria-hidden="true"></i>NAICS
        </button>
      </div>
      <div class="heading-seperator"></div>
      <div class="margin-bottom-10"></div>

      <div class="">
        <b-navbar toggleable="lg" type="light" variant="light">
          <b-navbar-brand href="#">Filter/Search</b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down	"></i></b-navbar-toggle>


          <b-collapse id="nav-collapse" is-nav>
      <div class="search-wrapper col-12">
      <div class="row col-12 override-padding">
        <div class="col-lg-4 col-md-6 col-6">
        <b-form-input
          class="input-text"
          v-model="search_description"
          type="text"
          placeholder="Description"
        ></b-form-input>
        </div>
        <div class="col-lg-4 col-md-6 col-6">
        <b-form-input
          class="input-text"
          v-model="search_code"
          type="text"
          placeholder="NAICS Number"
        ></b-form-input>
        </div>
        <div class="col-lg-3 col-md-10 col-10">
           <b-form-select class="input-text" v-model="search_naicsid" :options="naicsIdOptions"></b-form-select>
        </div>
        <div class="col-lg-1 col-md-2 col-2 search-icon-wrapper cursor-pointer" @click="filterNaicslistitems()">
        <span class="search-icon">
          <i class="fa fa-search"></i>
        </span>
        </div>
      </div>
      </div>
      </b-collapse>
    </b-navbar>
  </div>
      <div class="margin-bottom-10"></div>
      <div>
         <b-card no-body>
              <div class="row tasks_heading_row">
               <div
                 class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3"
                 v-on:click="sortMethod('naicsId')"
                 >
                 NAICS ID
                 <i v-if="sortField == 'naicsId' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                 <i v-if="sortField == 'naicsId' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
               </div>
               <div
                 class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                 v-on:click="sortMethod('naicsCode')"
                 >
                 NAICS Number
                 <i v-if="sortField == 'naicsCode' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                 <i v-if="sortField == 'naicsCode' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
               </div>
               <div
                 class="bold cursor-pointer col-xl-7 col-lg-7 col-md-7 col-sm-6 col-6 override-padding"
                 v-on:click="sortMethod('description')"
                 >
                 NAICS Description
                 <i v-if="sortField == 'description' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                 <i v-if="sortField == 'description' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
               </div>
             </div>

              <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
               <b-card-text v-if="naics_lists.length > 0">
                  <div v-for="(naicslist, index) in naics_lists" class="tasklist-row">
                  <div class="row tasklist-item"  style="margin: 0;">
                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 naics-title">{{naicslist.naicsCat}}</div>
                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding">{{naicslist.naicsCode}}</div>
                    <div class="col-xl-7 col-lg-7 col-md-7 col-sm-6 col-6 override-padding">{{naicslist.description}}</div>
                    <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding">
                        <div v-bind:id="'dropdown-container'+ index" class="dropdown" @click="toggleDropdown('actionDropdown'+index+'')">
                        <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu' + index">
                          <li></li>
                          <li></li>
                          <li></li>
                        </ul>
                        <div v-bind:id="'actionDropdown' + index" class="dropdown-content">
                          <div class="action-dd-menu"  @click="goToEdit(naicslist)"><i class="cursor-pointer fa fa-edit spacer-icon"></i>Edit</div>
                        </div>
                        </div>
                    </div>
                  </div>
                  <div><hr></div>
                  </div>
                  <div v-if="rows > 25" class="overflow-auto float-right pagination-wrapper">
                     <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                      last-text="Last"
                      :hide-goto-end-buttons=false
                      @input="showNaicsofPaginated()"
                      ></b-pagination>
                  </div>
               </b-card-text>
               <b-card-text v-else-if="loading == false">
                    No NAICS found.
               </b-card-text>

         </b-card>
     </div>
  </div>

  <CreateTasklistModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
    <span v-if="loading" class="pull-right text-danger">
      Loading...
    </span>
    <div slot="header" class="sub-heading"><h3>Create NAICS</h3></div>
    <div slot="body" v-if="isModalVisible === true">
      <div class="col-lg-12 col-12 override-padding">
        <input v-model="naics_title"
              placeholder="Description"
              class="col-12 input-height-30"
              maxlength="255"
              v-validate="'required'"
              name="Description"
              />
      <div v-if="verrors.firstByRule('Description', 'required')" class="margin-bottom-5 validate-warning-msg">Description is required</div>
      </div>
      <div style="clear: both;" class="margin-bottom-10"></div>
      <div class="col-12 override-padding">
         <div class="col-lg-6 col-12 float-left override-padding">
           <b-form-select class="input-text" v-model="naics_id" :options="naicsIdOptions"
           v-validate="'required'"
           name="NAICS ID"
           ></b-form-select>
       <div v-if="verrors.firstByRule('NAICS ID', 'required')" class="margin-bottom-5 validate-warning-msg">NAICS ID is required</div>
         </div>
         <div class="col-lg-6 col-12 float-left override-padding naics-code-wrapper">
         <input v-model="naics_code"
               placeholder="NAICS Number"
               class="col-12 input-height-30"
               maxlength="5"
               v-validate="'required|numeric'"
               name="NAICS Number"
               />
       <div v-if="verrors.firstByRule('NAICS Number', 'required')" class="margin-bottom-5 validate-warning-msg">NAICS Number is required</div>
       <div v-if="verrors.firstByRule('NAICS Number', 'numeric')" class="margin-bottom-5 validate-warning-msg">NAICS Number should be numeric</div>
         </div>
      </div>
      <div style="clear: both;" class="margin-bottom-10"></div>
      <div class="col-12 override-padding">
        <button
            v-on:click="createNaicsAction()"
            class="btn btn-blue col-3 float-left input-height-25"
            ><b>Create</b></button>
      </div>
    </div>
    <div slot="footer" class="col-3 override-padding">

    </div>
  </CreateTasklistModal>

  <EditNaicsModal :isModalVisible="isEditModalVisible" :editNaicsTitle="editNaicsTitle" :editNaicsCode="editNaicsCode" :editNaicsId="editNaicsId" :editId="editId" @close="isEditModalVisible = false">
    <span v-if="loading" class="pull-right text-danger">
      Loading...
    </span>
    <div slot="header" class="sub-heading"><h3>Edit NAICS</h3></div>
    <div slot="body" v-if="isEditModalVisible === true">
      <div class="col-lg-12 col-12 override-padding">
        <input v-model="editNaicsTitle"
              placeholder="Description"
              class="col-12 input-height-30"
              maxlength="255"
              v-validate="'required'"
              name="editNaicsTitle" />
        <div v-if="verrors.firstByRule('editNaicsTitle', 'required')" class="margin-bottom-5 validate-warning-msg">Description is required</div>
      </div>
      <div style="clear: both;" class="margin-bottom-10"></div>
      <div class="col-12 override-padding">
         <div class="col-lg-6 col-12 float-left override-padding">
           <b-form-select class="input-text" v-model="editNaicsId" :options="naicsIdOptions"
           v-validate="'required'" name="editNaicsId"></b-form-select>
         <div v-if="verrors.firstByRule('editNaicsId', 'required')" class="margin-bottom-5 validate-warning-msg">NAICS ID is required</div>
         </div>
         <div class="col-lg-6 col-12 float-left override-padding naics-code-wrapper">
         <input v-model="editNaicsCode"
               placeholder="NAICS Number"
               class="col-12 input-height-30"
               v-validate="'required|numeric'"
               name="editNaicsCode"
               maxlength="5" />
               <div v-if="verrors.firstByRule('editNaicsCode', 'required')" class="margin-bottom-5 validate-warning-msg">NAICS Number is required</div>
               <div v-if="verrors.firstByRule('editNaicsCode', 'numeric')" class="margin-bottom-5 validate-warning-msg">NAICS Number should be numeric</div>
         </div>
      </div>
      <div style="clear: both;" class="margin-bottom-10"></div>
      <div class="col-12 override-padding">
        <button
            v-on:click="updateNaics()"
            class="btn btn-blue col-3 float-left input-height-25"
            ><b>Update</b></button>
      </div>
    </div>
    <div slot="footer" class="col-3 override-padding">

    </div>
  </EditNaicsModal>

  <UploadNaicsModal :isModalVisible="isUploadModalVisible" @close="isUploadModalVisible = false">
    <span v-if="loading" class="pull-right text-danger">
      Loading...
    </span>
    <div slot="header" class="sub-heading"><h3>Upload CSV</h3></div>
    <div slot="body" v-if="isUploadModalVisible === true">
      <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
        <div class="col-lg-12 col-12 override-padding">
          <div class="dropbox">
            <input 
              type="file" 
              name="naics_csv" 
              :disabled="isSaving" 
              accept="type/csv"
              rules="required"
              @change="filesChange($event.target.name, $event.target.files)"
              class="input-file">
              <!-- <div v-if="verrors.firstByRule('ext_field', 'ext:jpeg,jpg')" class="margin-bottom-5 validate-warning-msg">File should be CSv</div> -->
              <p v-if="isInitial">Drag your file(s) here to begin<br> or click to browse</p>
              <p v-if="isSaving"> Uploading file... </p>
          </div>
          <p v-if="uploadError" class="text-danger">{{uploadError}}</p>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
      </form>
    </div>
    <div slot="footer" class="col-3 override-padding">

    </div>
  </UploadNaicsModal>

  </div>
  </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import CreateTasklistModal from '../admin/create-tasklist-modal.vue';
import EditNaicsModal from '../admin/edit-naics-modal.vue';
import UploadNaicsModal from '../admin/upload-naics-modal.vue';
import router from '../../router/index.js';
import DeleteModal from '../shared/delete_modal_alert.vue';
import ValidationModal from '../shared/validation_modal_alert.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';


const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

export default {
        data() {
          return {
            rows: 0,
            perPage: 25,
            currentPage: 1,
            naics_lists: [],
            search_keyword: '',
            search_status: '',
            loading: false,
            id: '',
            sortField: 'naicsCode',
            publicSortBy: 'ASC',
            tasklist_title: '',
            isModalVisible: false,
            isEditModalVisible: false,
            isUploadModalVisible: false,
            naics_id: '',
            naics_title: '',
            naics_code: '',
            naicsIdOptions: [{value: '', text: 'Select NAICS ID'}],
            editNaicsTitle: '',
            editNaicsCode: '',
            editNaicsId:'',
            editId: '',
            search_naicsid: '',
            search_code: '',
            search_description: '',
            uploadedFiles: [],
            uploadError: '',
            currentStatus: null,
            parse_csv: [],
          }
        },

        components: {
          UserMenu,
          GoBack,
          CreateTasklistModal,
          DeleteModal,
          ValidationModal,
          EditNaicsModal,
          UploadNaicsModal,
          MasteradminSidebarMenu
        },
        computed: {
          isInitial() {
            return this.currentStatus === STATUS_INITIAL;
          },
          isSaving() {
            return this.currentStatus === STATUS_SAVING;
          },
          isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
          },
          isFailed() {
            return this.currentStatus === STATUS_FAILED;
          }
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
            isActive: function (tabvalue) {
                 return this.selectedComponent === tabvalue
            },
            createNaicsAction() {
             this.$validator.validateAll().then((result) => {
              if (this.verrors.items.length === 0) {
                axios('/naicslists',
                   {
                     method: 'POST',
                     data: {
                            title: this.naics_title,
                            code: this.naics_code,
                            id: this.naics_id
                           },
                   }
                 )
                .then((resp) => {
                    this.naics_title = '';
                    this.naics_code = '';
                    this.naics_id = '';
                    this.isModalVisible = false;
                    this.fetchNaicsListitems();
                 })
                .catch(error => {
                  if(error.response.data.message == 'Access denied.') {
                    router.push("/forbidden");
                  }
                });
             }
            })
            .catch(() => {

            });
            },
            toggleDropdown (id) {
                document.getElementById(id).classList.toggle("show");
            },
            showNaicsofPaginated() {
               this.fetchNaicsListitems();
               this.filterFlag = false;
            },
            filterNaicslistitems() {
               this.filterFlag = true;
               this.fetchNaicsListitems();
            },
            fetchNaicsListitems() {
              this.loading = true;
              if(this.filterFlag) {
                 this.currentPage = 1;
              }
              const params = { _page: this.currentPage }
              if (this.search_description) {
                params.description = this.search_description;
              }
              if (this.search_code) {
                params.code = this.search_code
              }
              if (this.search_naicsid) {
                params.naicsid = this.search_naicsid
              }
              if (this.sortField) {
                params.sortfield = this.sortField
              }
              if (this.publicSortBy) {
                params.sortby = this.publicSortBy
              }
              axios.get('/naicslists', {
                 params: params
              })
              .then((resp) => {
                  this.loading = false;
                  this.naics_lists = resp.data.data;
                  this.currentPage = resp.data.page;
                  this.rows = resp.data.total_rows;
              })
              .catch(error => {

              });
            },
            goToEdit(naicslist) {
               this.editId = naicslist.id;
               this.editNaicsCode = naicslist.naicsCode;
               this.editNaicsTitle = naicslist.description;
               this.editNaicsId = naicslist.naicsId;
               this.isEditModalVisible = true;
            },
          hideActionMenu(e) {
             var matches = document.getElementsByClassName('dropdown-content');
             for (var i=0; i<matches.length; i++) {
               var container = document.getElementById('dropdown-container'+ i);

               if (!container.contains(e.target)) {
                    if (document.getElementById('actionDropdown' + i).classList.contains("show")) {
                       document.getElementById('actionDropdown' + i).classList.remove('show');
                    }
               }
             }
           },
           sortMethod: function(field) {
             this.sortField = field;
             if(this.publicSortBy == 'ASC') {
               this.publicSortBy = 'DESC';
             }
             else {
               this.publicSortBy = 'ASC';
             }
             this.fetchNaicsListitems();
           },
           updateNaics() {
           this.$validator.validateAll().then((result) => {
            if (this.verrors.items.length === 0) {
                 axios('/naicslists/'+this.editId,
                   {
                     method: 'PATCH',
                     data: {
                          title: this.editNaicsTitle,
                          naicsId: this.editNaicsId,
                          code: this.editNaicsCode
                          },
                      }
                   )
                .then((resp) => {
                    this.isEditModalVisible = false;
                    this.fetchNaicsListitems();
                 })
                .catch(error => {
                });

                }
               })
               .catch(() => {

               });
           },
            resetUpload() {
              // reset form to initial state
              this.currentStatus = STATUS_INITIAL;
              this.uploadedFiles = [];
              this.uploadError = null;
            },
            saveUpload(fileData) {
              // upload data to the server
              this.currentStatus = STATUS_SAVING;
              //console.log(fileData)

              axios.post('/naicslist-upload', fileData, {
                  headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Accept': 'text/csv',
                    'Content-Type': 'multipart/form-data'
                  },
              })
              .then(resp => {
                this.flash({ message: "The Naics List CSV file has been uploaded successfully.", variant: 'success' });
                this.currentStatus = STATUS_SUCCESS;
                this.isUploadModalVisible = false;
                this.resetUpload();
                this.fetchNaicsListitems();
                this.fetchNaicsIds();
              })
              .catch(error => {
                this.uploadError = error.response.data.message;
                this.currentStatus = STATUS_FAILED;
              })
            },
            filesChange(fieldName, fileList) {
              // handle file changes
              this.uploadError = '';
              const csvData = new FormData();

              if (!fileList.length) return;
              if(fileList[0].type !== "text/csv") {
                this.uploadError = 'Upload CSV file only'
                return
              }

              // append the files to FormData
              csvData.append(fieldName, fileList[0], fileList[0].name)
              //console.log(csvData)

              // save it
              this.saveUpload(csvData);
            },
            fetchNaicsIds() {
              axios('/naicsids',
                {
                  method: 'GET',
                },
              )
              .then(response => {
                  for(var i=0; i < response.data.length; i++) {
                    var naicsIdOption = {value: response.data[i].id, text: response.data[i].title};
                    this.naicsIdOptions.push(naicsIdOption);
                  }
                })
              .catch(error => {

              });
            }
          },
         mounted() {
            document.addEventListener('click', this.hideActionMenu);
            this.resetUpload();
         },
         beforeDestroy() {
            document.removeEventListener('click', this.hideActionMenu);
         },
         beforeCreate() {
           axios('/naicsids',
            {
               method: 'GET',
            },
           )
           .then(response => {
               for(var i=0; i < response.data.length; i++) {
                 var naicsIdOption = {value: response.data[i].id, text: response.data[i].title};
                 this.naicsIdOptions.push(naicsIdOption);
               }
            })
           .catch(error => {

           });
         },
         created() {
           this.fetchNaicsListitems();
           document.body.className = 'naicslist-page';
         },
    }
</script>

<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
.edit-action-btn {
  width: 70px;
  margin-right: 5px;
}
.deactivate-btn {
  width: 83px;
  margin-right: 5px;
}
.preview-wrapper {
  padding-right: 10px;
}
.btn-dark-grey, .btn-dark-grey:hover, .btn-dark-grey:focus {
  background-color: #555;
  color: #FFF;
  border: 1px solid #555;
}
.space-wrapper {
  padding-right: 10px;
}
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 25px;
  color: #FFF;
  padding: 3px 0px;
  margin-right: 0px;
  margin-left: 0px;
}
*, *::before, *::after {
  outline: none;
}
.input-height-30 {
  line-height: 30px;
}
.naics-code-wrapper {
  padding-left: 15px;
}
hr {
  border-top: 2px solid #8b8b8b;
  margin: 0px;
}
.tasklist-row:nth-of-type(odd) {
  background-color:#fff;
}
.tasklist-row:nth-of-type(even) {
  background-color:#e9e9e9;
}
.search-wrapper {
  background-color: transparent;
}
.heading-seperator {
  /* border-bottom: 2px solid #dc2227; */
  border-bottom: 2px solid #00ACEE;
}
.btn-blue {
  /* background-color: #dc2227 !important;
  border: 1px solid #dc2227 !important; */
  background-color: #00ACEE !important;
  border: 1px solid #00ACEE !important;
}
.create-btn {
    line-height: 15px;
    font-weight: bold;
    font-size: 13px;
}
.heading {
  font-size: 15px;
}
.tasklist-item {
  padding: 8px 0px 8px 0px;
}
.naics-title {
  padding-left: 20px;
}
/* Upload Form CSS Start */
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
/* Upload Form CSS End */
</style>







// WEBPACK FOOTER //
// src/components/admin/naics_list.vue